import React, { useState, useContext } from "react";
import { DeviceContext } from "context/deviceProvider";
import { Button, Form, Header, Modal } from "semantic-ui-react";
import "scss/components/modals/deviceStructure/addIoTNumberModal.scss";
import Swal from "sweetalert2";

export default function AddIoTNumberModal(props) {
  const [ioTNumber, setIoTNumber] = useState("");
  const deviceContext = useContext(DeviceContext);

  const alertDialog = async (title, text, icon) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: "ok",
      confirmButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed && icon === "success") {
        return props.isClose();
      }
    });
  };

  const onAddIoTNumber = async () => {
    if (ioTNumber.length < 1 || ioTNumber.length < 17) {
      alertDialog("Error!", "กรุณาตรวจสอบหมายเลขอุปกรณ์ IoT", "error");
      return;
    } else {
      let data = { serial: ioTNumber };
      let result = await deviceContext.addMasterDeviceSerial(data);

      //   ! -------- SHOW ALERT CONDITION --------
      if (result?.status?.result === "success") {
        await deviceContext.masterDeviceSerials({ serial: "" });
        await alertDialog("Success!", `Add ${ioTNumber} success`, "success");
      } else {
        alertDialog("Error!", `${result?.status?.description}`, "error");
      }
    }
  };

  return (
    <Modal open={props.isOpen} onClose={props.isClose} size="tiny">
      <Header icon="plus" content="&nbsp;เพิ่มหมายเลขอุปกรณ์ IoT" />
      <Modal.Content className="addIoTNumberModal">
        <Form>
          <Form.Input
            label="หมายเลขอุปกรณ์ IoT"
            type="text"
            maxLength={17}
            onChange={(e) => setIoTNumber(e.target.value)}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" onClick={() => props.isClose()}>
          ยกเลิก
        </Button>

        <Button color="green" onClick={() => onAddIoTNumber()}>
          เพิ่ม
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
